'use strict';

import { baseInit, baseInitGpt, baseSetupHeroSkin } from './_base';
import foundationLoader from '../utils/foundation-loader';
import fullScreenGallery from '../components/full-screen-gallery';
import previewSlider from '../components/preview-slider';
import footerNav from '../components/review/footer-nav';
import videoPlayer from '../components/video-player';
import affiliateLinks from '../utils/affiliate-links';

const classNames = {
	reviewDetails: 'review-details',
	reviewDetailsCosts: 'review-details-costs',
	heading: 'heading',
	fuelCostsInfoButton: 'fuel-costs__info-button',
	fuelCostsText: 'fuel-costs__text'
}

export function init() {
	const foundationPlugins = [];
	const $faqBlock = $.findByBem('faq-block');
	if ($faqBlock.length > 0) {
		foundationPlugins.push(foundationLoader.PLUGINS.ACCORDION);
	}

	baseInit(foundationPlugins);
	fullScreenGallery.init();
	previewSlider.init();
	footerNav.init();
	videoPlayer.init();
	affiliateLinks.init();
	$.findByBem(classNames.reviewDetailsCosts, classNames.fuelCostsInfoButton).off('click.costs').on('click.costs', (e) => {
		e.preventDefault();
		const $heading = $(event.target).closestByBem(classNames.reviewDetails, classNames.heading);
		$heading.siblingsByBem(classNames.reviewDetailsCosts, classNames.fuelCostsText).slideToggle();
	})
}

export function initGpt(adConfig) {
	baseInitGpt(adConfig);
}

export function setupHeroSkin(options) {
	baseSetupHeroSkin(options);
}